<section class="plans-simulator">
    <form [formGroup]="form" (submit)="onSubmit()" *ngIf="form">
        <div class="columns plans-simulator__columns">
            <div class="column is-4 plans-simulator__columns-column">
                <div class="plans-simulator__columns-column--start">
                    <p class="plans-simulator__columns-column--start__full">
                        Na Montreal Viagens você tem diárias para usar todos os anos nas melhores acomodações do Brasil
                        e até do exterior. Monte sua Assinatura agora e garanta nossos benefícios!
                    </p>
                    <h2 class="plans-simulator__columns-column--start__half"><strong>Monte sua Assinatura</strong></h2>
                </div>
            </div>
            <div class="column is-6 plans-simulator__columns-column">
                <div class="plans-simulator__columns-column--center columns">
                    <div class="plans-simulator__columns-column--center__plan column">
                        <label for="plan">
                            <span><i class="fas fa-calendar"></i> Plano</span>
                        </label>
                        <select id="plan" formControlName="plan" (change)="onChangePlan()" class="plans-simulator__columns-column--center__plan-select">
                            <option *ngFor="let item of plans" value="{{item.codigoCategoria}}">
                                {{item.descricao}}
                            </option>
                        </select>
                    </div>
                    <div class="plans-simulator__columns-column--center__daily column">
                        <div class="plans-simulator__columns-column--center__daily-full">
                            <label for="daily">
                                <span><i class="fas fa-calendar"></i> Diárias</span>
                            </label>
                            <div class="plans-simulator__columns-column--center__daily-full__area">
                                <a class="plans-simulator__columns-column--center__daily-full__area-decrement" (click)="dailyDecrement()">–</a>
                                <input id="daily" type="number" min="{{minimumDaily}}" max="28" formControlName="daily" readonly class="plans-simulator__columns-column--center__daily-full__area-input">
                                <a class="plans-simulator__columns-column--center__daily-full__area-increment" (click)="dailyIncrement()">+</a>
                            </div>

                        </div>
                        <div class="plans-simulator__columns-column--center__daily-half">
                            <label for="dailySelect">
                                <span><i class="fas fa-calendar"></i> Diárias</span>
                            </label>
                            <select id="dailySelect" formControlName="daily" (change)="onChangeDaily()" class="plans-simulator__columns-column--center__daily-half--select">
                                <option *ngFor="let item of dailyArray" value="{{item}}">
                                    {{item}}
                                </option>
                            </select>
                        </div>

                    </div>
                    <div class="plans-simulator__columns-column--center__bedrooms column">
                        <label for="bedrooms">
                            <span><i class="fas fa-bed"></i> Quartos</span>
                        </label>
                        <select id="bedrooms" formControlName="bedrooms" (change)="onChangeBedrooms()" class="plans-simulator__columns-column--center__bedrooms-select">
                            <option *ngFor="let item of typesOfRooms" value="{{item.value}}">
                                {{item.label}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="column is-3 plans-simulator__columns-column">
                <div class="plans-simulator__columns-column--end">
                    <div class="plans-simulator__columns-column--end__flat-values">
                        <span>Valor mensal da assinatura</span>
                        <u>{{monthlyValue !== null ? monthlyValue : '' | currency: 'BRL': true : '1.2-2' }}</u>
                    </div>
                    <div class="plans-simulator__columns-column--end__button">
                        <button class="btn btn-submit" type="submit">Assine Agora</button>
                    </div>
                </div>
            </div>
        </div>
    </form>

</section>

